import React from 'react'

import Script from 'next/script'

const TeadsTag = () => {
  return (
    <Script
      className='teads'
      data-testid='teads-script'
      id='teads-tag'
      src='//a.teads.tv/page/141733/tag'
      strategy='beforeInteractive'
    />
  )
}

export default TeadsTag
